import { appendIf } from '@btime/helpers'
import { assoc, compose, dissoc, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { generalClient } from '../../../../utils/apollo/api'
import { toKebabCase } from '../../../../utils/helpers/string'
import { useNavigationWithModalCloser } from '../../../../utils/contexts/NavigationContext'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertScreen($input: ScreenInput) {
    upsertScreen(input: $input) {
      id
      name
    }
  }
`

const cleanUserGroups = userGroups => {
  if (!userGroups || !userGroups.length) {
    return []
  }
  const groupIds = userGroups.map(group => group.id)

  return groupIds
}

const cleanRequest = (form, isCloning) => {
  return compose(
    pick(['id', 'name', 'screen', 'data', 'userGroups']), //
    item => (isCloning ? dissoc('id', item) : item),
    item => assoc('data', isCloning ? JSON.stringify({ ...form.data }) : undefined, item),
    item => assoc('userGroups', cleanUserGroups(item.userGroups), item)
  )(form)
}

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }), //
    ...appendIf(!form.name, { path: ['screen'], message: 'Campo obrigatório' }) //
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveScreen = () => {
  const navigate = useNavigationWithModalCloser()
  const closeModal = useCloseModal()
  const { isCloning, origin } = useModalData()

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Screens'], client: generalClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form, isCloning)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          if (origin === 'dashboard') {
            closeModal()
          } else {
            navigate(`/${toKebabCase(input.screen)}/kanban/${resp?.data?.upsertScreen?.id}`)
          }
        }
      })
    }
  }

  return [handleRequest, state]
}
